module.exports = __webpack_public_path__ + "img/bybit_600rewards_321x101.d0556ecc.png";